import { useEffect } from "react";

import { useCrumbs } from "@/hooks/use-crumbs";

const APP_NAME = "victoria";
const TITLE_TRUNCATE_THRESHOLD = 50;
const TITLE_TRUNCATE_TO = 20;

export default function PageTitle() {
  const crumbs = useCrumbs();
  const lastNode = crumbs[crumbs.length - 1]?.node;

  useEffect(() => {
    let title = APP_NAME;
    // crumb() may return a React element (e.g. dynamic ItemCrumb); only use
    // it as a page-title string when it's actually a string.
    if (typeof lastNode === "string" && lastNode.length > 0) {
      const trimmed =
        lastNode.length > TITLE_TRUNCATE_THRESHOLD
          ? `${lastNode.substring(0, TITLE_TRUNCATE_TO)}...`
          : lastNode;
      title = `${trimmed} - ${APP_NAME}`;
    }
    document.title = title;
  }, [lastNode]);

  return null;
}
